export const ROOT = '/';
export const STORY_ROUTE = `${ROOT}stories/:story_id`;
